import { __rest } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import Heading from '../Heading';
import Text from '../Text';
import { st, classes } from './TableToolbar.st.css.js';
export const Title = ({ dataHook, className, children }) => (React.createElement(Heading, { dataHook: dataHook, className: st(classes.title, {}, className), size: "medium" }, children));
Title.propTypes = {
    dataHook: PropTypes.string,
    className: PropTypes.string,
};
Title.displayName = 'TableToolbar.Title';
export const SelectedCount = ({ dataHook, className, children }) => (React.createElement(Text, { dataHook: dataHook, className: className, weight: "thin", size: "small" }, children));
SelectedCount.propTypes = {
    dataHook: PropTypes.string,
    className: PropTypes.string,
};
SelectedCount.displayName = 'TableToolbar.SelectedCount';
export const ItemGroup = ({ dataHook, position, children, className }) => (React.createElement("div", { "data-hook": dataHook, className: st(classes.itemGroup, { position }, className) }, children));
ItemGroup.propTypes = {
    dataHook: PropTypes.string,
    className: PropTypes.string,
    position: PropTypes.oneOf(['start', 'end']),
};
ItemGroup.defaultProps = {
    position: 'start',
};
ItemGroup.displayName = 'Toolbar.ItemGroup';
export const Item = ({ children, layout, className, dataHook }) => (React.createElement("span", { "data-hook": dataHook, className: st(classes.item, { layout }, className) }, children));
Item.propTypes = {
    dataHook: PropTypes.string,
    className: PropTypes.string,
    layout: PropTypes.oneOf(['button']),
};
Item.displayName = 'Toolbar.Item';
export const Label = (_a) => {
    var { children, className } = _a, rest = __rest(_a, ["children", "className"]);
    return (React.createElement(Text, Object.assign({ tagName: "label" }, rest, { className: st(classes.itemLabel, {}, className), weight: "thin", size: "small" }), React.Children.toArray(children).map((c, index) => {
        return typeof c === 'string' ? React.createElement("span", { key: index }, c) : c;
    })));
};
Label.propTypes = {
    dataHook: PropTypes.string,
    className: PropTypes.string,
};
Label.displayName = 'Toolbar.Label';
export const Divider = ({ className, dataHook }) => (React.createElement("span", { "data-hook": dataHook, className: st(classes.divider, {}, className) }));
Divider.propTypes = {
    dataHook: PropTypes.string,
    className: PropTypes.string,
};
Divider.displayName = 'Toolbar.Divider';
//# sourceMappingURL=Compounds.js.map